import axios from './providers/axios';

const promotionCodeService = {
    getPromotionCodes(params = {}) {
        return axios.get(`/v1/admin/promotionCode/store`, { params });
    },
    getPromotionCode(id) {
        return axios.get(`/v1/admin/promotionCode/getFromId/${id}`);
    },
    deletePromotionCode(promotionCodeId) {
        return axios.delete(`/v1/admin/promotionCode/delete/${promotionCodeId}`);
    },
    createPromotionCode(data) {
        return axios.post(`/v1/admin/promotionCode/add`, data);
    },
    updatePromotionCode(data) {
        return axios.post(`/v1/admin/promotionCode/update`, data);
    },
    validatePromotionCode(data){
        return axios.post(`/v1/admin/promotionCode/validate`, data);
    }
}

export default promotionCodeService;
